import { Avatar } from 'modules/layouts/LoggedLayout/components/Navbar/subcomponents/Avatar';
import { FC, memo, useMemo } from 'react';
import { useJobPositions } from 'shared/hooks/useJobPositions';

interface UserBadgeProps {
  firstName: string;
  lastName: string;
  jobPositionId: string;
  avatarUrl: string;
  // onProfilePreviewClick: () => void;
}

export const UserBadge: FC<UserBadgeProps> = memo(
  ({ firstName, lastName, jobPositionId, avatarUrl }) => {
    const { getJobPositionById } = useJobPositions();

    const jobPosition = useMemo(() => getJobPositionById(jobPositionId), [jobPositionId]);

    return (
      <div className="flex flex-row gap-3 px-4 lg:flex-col lg:items-center lg:justify-center lg:gap-2 lg:text-center">
        <Avatar url={avatarUrl} />
        <div className="flex flex-col items-start lg:items-center">
          <p className="text-base font-bold text-white lg:text-black">
            {firstName} {lastName}
          </p>
          <p className="font-medium text-gray-400 lg:text-gray">
            {jobPosition?.name ?? jobPositionId}
          </p>
          {/*
          @TODO to be implemented in @https://hoqus.atlassian.net/browse/CM-2954
          <Button
            onClick={onProfilePreviewClick}
            className="mt-2.5 lg:mt-3.5"
            variant="text"
            color={isMobile ? 'white' : 'primary'}
            name="profilePreviewButton"
          >
            {t('action:profilePreview')}
          </Button> */}
        </div>
      </div>
    );
  },
);
